<script>
  import { onMount } from 'svelte';
  import Router, { wrap, push } from 'svelte-spa-router'

  import { user } from './store/store.js';
  import { verifyUserSession } from './actions/session.js';

  import Login from './pages/Login.svelte';
  import NotFound from './pages/404.svelte';

  import Produtos from './pages/Produtos/Produtos.svelte';
  import CriarProduto from './pages/Produtos/Criar.svelte';
  import EditarProduto from './pages/Produtos/Editar.svelte';

  import Categorias from './pages/Categorias/Categorias.svelte';
  import CriarCategoria from './pages/Categorias/Criar.svelte';
  import EditarCategoria from './pages/Categorias/Editar.svelte';

  import Promocoes from './pages/Promocoes/Promocoes.svelte';
  import CriarPromocao from './pages/Promocoes/Criar.svelte';
  import EditarPromocao from './pages/Promocoes/Editar.svelte';

  import Banners from './pages/Banners/Banners.svelte';
  import CriarBanner from './pages/Banners/Criar.svelte';
  import EditarBanner from './pages/Banners/Editar.svelte';

  import Espacos from './pages/Espacos/Espacos.svelte';
  import CriarEspaco from './pages/Espacos/Criar.svelte';
  import EditarEspaco from './pages/Espacos/Editar.svelte';

  import './styles/MenteAberta.scss';

  const protectedRoute = Component => wrap(
    Component,
    user,
    (detail) => {
      return $user;
    }
  );

  onMount(() => {
    verifyUserSession();
  });

  const routes = {
    '/login': Login,
    '/painel': protectedRoute(Produtos),
    '/painel/produtos': protectedRoute(Produtos),
    '/painel/produtos/criar': protectedRoute(CriarProduto),
    '/painel/produtos/:id': protectedRoute(EditarProduto),
    '/painel/categorias': protectedRoute(Categorias),
    '/painel/categorias/criar': protectedRoute(CriarCategoria),
    '/painel/categorias/:id': protectedRoute(EditarCategoria),
    '/painel/promocoes': protectedRoute(Promocoes),
    '/painel/promocoes/criar': protectedRoute(CriarPromocao),
    '/painel/promocoes/:id': protectedRoute(EditarPromocao),
    '/painel/banners': protectedRoute(Banners),
    '/painel/banners/criar': protectedRoute(CriarBanner),
    '/painel/banners/:id': protectedRoute(EditarBanner),
    '/painel/espacos': protectedRoute(Espacos),
    '/painel/espacos/criar': protectedRoute(CriarEspaco),
    '/painel/espacos/:id': protectedRoute(EditarEspaco),
    '/': Login,
    '*': NotFound
  }
</script>

<Router
  {routes}
  on:conditionsFailed={
    () => push('/login')
  }
/>